import AsyncCreatableReactSelect from '@atlaskit/react-select/async-creatable';

import createSelect from './createSelect';

const AsyncCreatableSelect = createSelect(AsyncCreatableReactSelect);

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default AsyncCreatableSelect;
